import React, { Component } from "react";
import flashLogo from "assets/img/flash_color_logo_text@3x.png";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

class CalculatorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeCount: this.props.formData.employeeCount || "",
      price: this.props.formData.price || "",
      opdAllocation: this.props.formData.opdAllocation || "",
      savingsOnOPD: this.props.formData.savingsOnOPD || "",
      medicineDelivery: this.props.formData.medicineDelivery || "",
      homeLabService: this.props.formData.homeLabService || "",
      doctorConsult: this.props.formData.doctorConsult || "",
      savingsSharePercent: this.props.formData.savingsSharePercent || "",
      employeeCountError: null,
      priceError: null,
      opdAllocationError: null,
      savingsOnOPDError: null,
      medicineDeliveryError: null,
      doctorConsultError: null,
      savingsSharePercentError: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== this.props.activeTab) {
      this.setState({
        employeeCount: this.props.formData.employeeCount || "",
        price: this.props.formData.price || "",
        opdAllocation: this.props.formData.opdAllocation || "",
        savingsOnOPD: this.props.formData.savingsOnOPD || "",
        medicineDelivery: this.props.formData.medicineDelivery || "",
        homeLabService: this.props.formData.homeLabService || "",
        doctorConsult: this.props.formData.doctorConsult || "",
        savingsSharePercent: this.props.formData.savingsSharePercent || "",
        employeeCountError: null,
        priceError: null,
        opdAllocationError: null,
        savingsOnOPDError: null,
        medicineDeliveryError: null,
        doctorConsultError: null,
        savingsSharePercentError: null,
      });
    }
  }

  syncDataWithParent = () => {
    const formData = {
      employeeCount: this.state.employeeCount,
      price: this.state.price,
      opdAllocation: this.state.opdAllocation,
      savingsOnOPD: this.state.savingsOnOPD,
      medicineDelivery: this.state.medicineDelivery,
      homeLabService: this.state.homeLabService,
      doctorConsult: this.state.doctorConsult,
      savingsSharePercent: this.state.savingsSharePercent,
    };

    this.props.onFormDataChange(formData);
    this.props.onFormSubmit(formData);
  };

  handleSubmit = () => {
    let hasError = false;

    const {
      employeeCount,
      price,
      opdAllocation,
      savingsOnOPD,
      medicineDelivery,
      doctorConsult,
      savingsSharePercent,
    } = this.state;

    this.setState({
      employeeCountError: null,
      priceError: null,
      opdAllocationError: null,
      savingsOnOPDError: null,
      medicineDeliveryError: null,
      doctorConsultError: null,
      savingsSharePercentError: null,
    });

    if (!employeeCount || employeeCount <= 0) {
      this.setState({
        employeeCountError: (
          <small className="text-danger">
            Number of Employees is required.
          </small>
        ),
      });
      hasError = true;
    }

    if (!price || price <= 0) {
      this.setState({
        priceError: <small className="text-danger">Price is required.</small>,
      });
      hasError = true;
    }

    if (!opdAllocation || opdAllocation <= 0) {
      this.setState({
        opdAllocationError: (
          <small className="text-danger">OPD Allocation is required.</small>
        ),
      });
      hasError = true;
    }

    if (!savingsOnOPD || savingsOnOPD <= 0) {
      this.setState({
        savingsOnOPDError: (
          <small className="text-danger">Savings on OPD is required.</small>
        ),
      });
      hasError = true;
    }

    if (!medicineDelivery || medicineDelivery <= 0) {
      this.setState({
        medicineDeliveryError: (
          <small className="text-danger">Medicine Delivery is required.</small>
        ),
      });
      hasError = true;
    }

    if (!doctorConsult || doctorConsult <= 0) {
      this.setState({
        doctorConsultError: (
          <small className="text-danger">Doctor Consult is required.</small>
        ),
      });
      hasError = true;
    }

    if (this.props.activeTab === "annual") {
      if (!savingsSharePercent || savingsSharePercent <= 0) {
        this.setState({
          savingsSharePercentError: (
            <small className="text-danger">
              Savings Share Percentage is required.
            </small>
          ),
        });

        hasError = true;
      }
    }

    if (!hasError) {
      this.syncDataWithParent();
    }
  };

  render() {
    return (
      <form>
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "5px",
            padding: "20px",
            boxShadow: "0px 6px 10px -3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Number of Employees</ControlLabel>
                <FormControl
                  name="employeeCount"
                  value={this.state.employeeCount}
                  onChange={(event) =>
                    this.setState({
                      employeeCount: event.target.value,
                    })
                  }
                  placeholder="100"
                  type="number"
                />
                {this.state.employeeCountError}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Price (Per User)</ControlLabel>
                <FormControl
                  name="price"
                  value={this.state.price}
                  onChange={(event) => {
                    this.setState({
                      price: event.target.value,
                    });
                  }}
                  placeholder="150"
                  type="number"
                />
                {this.state.priceError}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>OPD Allocation (Per Annum)</ControlLabel>
                <FormControl
                  name="opdAllocationAmount"
                  value={this.state.opdAllocation}
                  onChange={(event) => {
                    this.setState({
                      opdAllocation: event.target.value,
                    });
                  }}
                  placeholder="15,000"
                  type="number"
                />
                {this.state.opdAllocationError}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Average Savings on OPD (%)</ControlLabel>
                <FormControl
                  name="savingsOnOPD"
                  value={this.state.savingsOnOPD}
                  onChange={(event) => {
                    this.setState({
                      savingsOnOPD: event.target.value,
                    });
                  }}
                  disabled
                  placeholder="32.5"
                  type="number"
                />
                {this.state.savingsOnOPDError}
              </FormGroup>
            </Col>
          </Row>
          {this.props.activeTab === "annual" ? (
            <Row>
              <Col xs={12} md={12}>
                <FormGroup>
                  <ControlLabel>Savings Share (%)</ControlLabel>
                  <FormControl
                    name="savingsShare"
                    value={this.state.savingsSharePercent}
                    onChange={(event) => {
                      this.setState({
                        savingsSharePercent: event.target.value,
                      });
                    }}
                    placeholder="50"
                    type="number"
                  />
                  {this.state.savingsSharePercentError}
                </FormGroup>
              </Col>
            </Row>
          ) : null}
        </div>

        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "5px",
            padding: "20px",
            marginTop: "20px",
            boxShadow: "0px 6px 10px -3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Medicine Delivery</ControlLabel>
                <FormControl
                  name="medicineDelivery"
                  value={this.state.medicineDelivery}
                  onChange={(event) => {
                    this.setState({
                      medicineDelivery: event.target.value,
                    });
                  }}
                  placeholder="4"
                  type="number"
                />
                {this.state.medicineDeliveryError}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Home Lab Services (Discount %)</ControlLabel>
                <FormControl
                  name="homeLabService"
                  value={this.state.homeLabService}
                  onChange={(event) => {
                    this.setState({
                      homeLabService: event.target.value,
                    });
                  }}
                  placeholder="4"
                  type="number"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <FormGroup>
                <ControlLabel>Doctor Consult</ControlLabel>
                <FormControl
                  name="doctorConsult"
                  value={this.state.doctorConsult}
                  onChange={(event) => {
                    this.setState({
                      doctorConsult: event.target.value,
                    });
                  }}
                  placeholder="4"
                  type="number"
                />
                {this.state.doctorConsultError}
              </FormGroup>
            </Col>
          </Row>
        </div>
        <Row
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "#fff",
            padding: "10px 0",
            zIndex: 999,
          }}
        >
          <Col xs={12} md={12}>
            <Button
              className="btn"
              onClick={this.handleSubmit}
              style={{
                width: "100%",
                backgroundColor: "#CF2A3B",
                border: "0px",
                fontWeight: "bold",
                color: "#FFFFFF",
              }}
            >
              Calculate Savings
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}

export default CalculatorForm;
